import { useEffect, useState } from 'react';
import { ThreeCirclesLoading } from '../hoc/threeCirclesLoading';
import parse from 'html-react-parser';
import { ProcessedLessonWidgetTextMath } from '../../helpers/processedLessonWidgetTextMath';
import { StandardsSubMapping } from './standardsSubMapping';
import Aux from '../hoc/auxiliary'
import { Icon } from '../common/icons';
import { getStaticAppSettings } from './../../utils/envService'

export const StandardsDetailMapping = ({ detail, setPageResults, description, clickDetail, activeDetail, coverageAcceptance, setGeneratingResults, generatingResults, standardMappingResults, standardGrade, standard }) => {

  const [ generatingDetail, setGeneratingDetail ] = useState(false)
  const [ showDetails, setShowDetails ] = useState(false)
  const [ results, setResults ] = useState(false)

  const isStaging = process.env.NEXT_PUBLIC_REACT_APP_ENVIRONMENT === 'staging' ? true : false;


  useEffect(() => {

    if(standardMappingResults && standardMappingResults.find(s => s.standard_id === detail.UNIQUE_ID)){
      setResults(JSON.parse(standardMappingResults.find(s => s.standard_id === detail.UNIQUE_ID).resources).sort((a,b) => parseFloat(b.completionLevel) - parseFloat(a.completionLevel)))
  }


  }, [standardMappingResults])

  useEffect(() => {

    if(activeDetail && activeDetail.UNIQUE_ID === detail.UNIQUE_ID && results){

          setPageResults(results)
    }

  }, [activeDetail, results])





  const handleSearchCount = (e) => {

    console.log("click")

      getStaticAppSettings(process.env.NODE_ENV).then((settings) => {

    const bodyToSend = {
    queryVector: detail.STANDARD_DESCRIPTION_SKILL_COMPETENCY_TITLE_EMBEDDING,
    itemDescription: description,
    title: detail.SKILL_COMPETENCY_TITLE,
    standardId: detail.UNIQUE_ID,
    standardGrade: standardGrade
  }

  setGeneratingResults(true)

  // let headers = new Headers(authHeader())
  // headers.append('Content-type','application/json')

  // make a POST call to our api route
  return fetch(`${settings.MAPPING_API_URL}/standards/search-resources`, {
  method: 'POST',
  headers: {
      "Content-Type": 'application/json',
    },
  body: JSON.stringify(bodyToSend)

  }) .then(response => {
  if (!response.ok) {
  throw new Error('Network response was not ok');
  }
  // return response.json(); // This returns a promise

  return response.json()
  })
  .then(data => {

      console.log("data", data)
      // setSectionStandards(data)

  // setResults(data.sort((a,b) => parseFloat(b.completionLevel) - parseFloat(a.completionLevel)))
  setGeneratingResults(false)
  })
  .catch(error => {
  console.error('There was a problem with the fetch operation:', error);

  // setResults(json.sort((a,b) => b.score - a.score))
  // console.log("results", json)
  // setGeneratingResults(false)
  })

})



    //Go through ai and save to database if results are not already coming from database. Will we still need this?
    // try {

    // //  e.preventDefault()
    //  setGeneratingDetail(true)

  

    //  let subjectsList = []
    //  let yearsList = []
    //   if(standard){
    //  standard.listOfSubjects.forEach(s => {
    //   subjectsList.push(s.description.trim().split(" ").map(su => su.toLowerCase()).join("-"))
    //  })

    //  standard.listOfYearNumbers.forEach(s => {
    //   yearsList.push(s.description.trim().split(" ").map(su => su.toLowerCase()).join("-"))
    //  })
    // }


    //  const bodyToSend = {
    //   subjectsFilter: subjectsList,
    //   yearGroupsFilter: yearsList,
    //   filterPublishers: publisherFilter.title,
    //   searchQuery: detail ? (standard.id === 1134 || standard.id === 1133 || standard.id === 1132 || standard.id === 1131 || standard.id === 1130) ? standardSection.description : detail.description : " ",
    //   gptDemo: demo && publisherFilter.demo && publisherFilter.demo.find(d => d === demo) ? demo : null,
    //   vectorAcceptance,
    //   skill: standard.id === 1134 || standard.id === 1133 || standard.id === 1132 || standard.id === 1131 || standard.id === 1130 ? detail.description : false,
    //   clarificationStatement: detail.curriculumSubObjectives && detail.curriculumSubObjectives.find(c => c.type === 'Clarification Statement') ? detail.curriculumSubObjectives.find(c => c.type === 'Clarification Statement').description : false,
    //   assessmentBoundary: detail.curriculumSubObjectives && detail.curriculumSubObjectives.find(c => c.type === 'Assessment Boundary') ? detail.curriculumSubObjectives.find(c => c.type === 'Assessment Boundary').description : false,
      

    //  }
  
    //  // make a POST call to our api route
    //  let res = await fetch('/api/search', {
    //   method: 'POST',
    //   headers: {
    //    'Content-type': 'application/json',
    //   },
    //   body: JSON.stringify(bodyToSend)
    
    //  })
  
    //  if (res.ok) {
    //   const json = await res.json();
    //   // https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream/getReader
    //   if(json && json.results){

    //       setResults(json.results)

    //   setGeneratingDetail(false)
    //   const sectionIndex = parseInt(index.split("-")[0])
    //   const detailIndex = parseInt(index.split("-")[1])
    //   const goToNextIndex = detailIndex + 1 === detailLength
    //   const newSectionIndex = goToNextIndex ? sectionIndex + 1 : sectionIndex
    //   const newDetailIndex = goToNextIndex ? 0 : detailIndex + 1
    //   setIndexFound(`${newSectionIndex}-${newDetailIndex}`)

    //   if(resourcesFromDb){

    //     const resultsArray = json.results.map(r =>{

    //       const rId = parseInt(r.id.split("_")[1],10)
    //       // const rId = Math.round(Math. random() * (24200 - 24100) + 24100)

    //       const result = {
    //           resourceId: rId,
    //           nationalCurriculumObjectiveId: detail.id,
    //           score1: r.score,
    //           score2: parseFloat(r.completionLevel),
    //           explanation: r.completionExplanation
    //       }

    //       return result
    //     })


    //     const apiBaseUrl = `${config.apiUrl}CognitiveSearch/AddOrUpdateStandardsMapping/${parseInt(publisherFilter.userId,10)}`;
    //     axios.post(apiBaseUrl, resultsArray, {
    //         headers: authHeader(),
    //     }).then(response => {
            
    //         console.log("done", response)
            
    //     }).catch(function (error) {
    //         console.log('Looks like there was a problem: \n', error);
         
    //     });
        

    //   }



    //   if(index === finalIndex){
    //     setRefreshDataLoading(false)
    //   }
      
    //  }
    // }
   
  
    //   else {
    //   alert(`error getting response`)
    //   setGeneratingDetail(false)
    //  }
    // } catch (error) {
    //  alert(`error: ${error.message}`)
    //  setGeneratingDetail(false)
    // }
    e && e.stopPropagation()
  }


  const completionToColor = (score) => {

    const colorArray = ["#FF0000", "#FF8A00", "#FFF500", "#9EFF00", "#61FF00", "#00FF47", "#00FF94", "#00ffbb", "#00ffd0", "#00ffe5"]

    const normalisedScore = Math.round(parseInt(score*5,10))
  if(normalisedScore >= 10){
      return "#2291E1"
    } else {
      return colorArray[normalisedScore]
    }


  }


    return (
      <Aux>
        <div className={(generatingResults) ? 'gpt-standards__detail gpt-standards__detail--loading' : activeDetail && activeDetail.SPINE_NODE_ID === detail.SPINE_NODE_ID ?  'gpt-standards__detail gpt-standards__detail--active' :  'gpt-standards__detail'} onClick={() => clickDetail(detail, results)}>
          <div style={{display: 'flex', alignItems: 'center', gap: '1.2rem'}}>
            {detail.curriculumSubObjectives && detail.curriculumSubObjectives.length > 0 &&
          <div onClick={() => setShowDetails(prev => !prev)} className="ai-body-medium ai-grey-100">
          <Icon name={showDetails ? 'chevron-down' : 'chevron-right'} customClass="icon--normal" />
          </div>
          }
          <ProcessedLessonWidgetTextMath customClass={'ai-body-medium black'} text={detail.code ? `${parse(detail.description)} (${detail.code})` : parse(detail.SKILL_COMPETENCY_TITLE)} />
          </div>
            {/* <ThreeCirclesLoading loading={generatingDetail} size={20} color={'#000000'}> */}
              <div className="gpt-standards__detail--score">
              {/* <button className="btn small round primary" style={{position: 'absolute', top: 0, right: 0}} onClick={(e) => handleSearchCount(e)}>
                <div className="ai-body-small">Refresh</div></button> */}
              {results && !generatingDetail && <div className="ai-body-small ai-grey-100" style={{backgroundColor: '#FFFFFF', borderColor: '#000000', borderWidth: '1px', borderStyle: 'solid'}}>{`${results.length}`}</div>}
              {results && !generatingDetail && <div className="ai-body-small ai-grey-100 bold" style={{backgroundColor: '#FFFFFF', borderWidth: '2px', borderStyle: 'solid', borderColor: completionToColor(coverageAcceptance)}}>{`${results.filter(r => parseFloat(r.completionLevel) >= coverageAcceptance).length}`}</div>}
              </div>
              
            {/* </ThreeCirclesLoading> */}
            {(generatingResults) && <div className="gpt-standards__loading"></div>}
        </div>
        {/* {showDetails &&

        <Aux>

          {detail.curriculumSubObjectives.map(c => {

            return(

              <div key={c.id}>
              
              <StandardsSubMapping detail={c} standard={standard}  clickDetail={clickDetail} coverageAcceptance={coverageAcceptance} resourcesFromDb={resourcesFromDb} clarificationStatement={detail.curriculumSubObjectives && detail.curriculumSubObjectives.find(c => c.type === 'Clarification Statement') ? detail.curriculumSubObjectives.find(c => c.type === 'Clarification Statement').description : false} activeDetail={activeDetail}/>
              </div>
            )
          })}



        </Aux>
        
        
        } */}
        </Aux>
    

          
    );
};